import {Injectable} from '@angular/core';
import firebase from 'firebase';
import {UtilService} from './util.service';
import {AngularFireAuth} from '@angular/fire/auth';
import {StorageService} from './storage.service';
import {BrainService} from './brain.service';
import auth = firebase.auth;
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public currentUser: firebase.User;

  constructor(
    public fireAuth: AngularFireAuth,
    private util: UtilService,
    private storage: StorageService,
    private brain: BrainService
  ) {
    this.fireAuth.onAuthStateChanged((user) => {
      if (user) {
        this.currentUser = user;
        this.brain.initializeUser(user.uid);
      } else {
        this.currentUser = null;
        this.storage.clear();
      }
    });
  }

  // Getters
  getCurrentUser(): firebase.User | null {
    return this.currentUser;
  }

  async getAbsolutUser(): Promise<firebase.User> {
    return new Promise((resolve) => {
      setTimeout(() => {
        if (this.currentUser) {
          resolve(this.currentUser);
        } else {
          this.loginAnonymously().then((cred) => {
            resolve(cred.user);
          });
        }
      }, 4000);
    });
  }

  // Main Functions
  async loginWithEmail(email: string, password: string) {
    console.log(`Email: ${email} Password: ${password}`);
    return new Promise((resolve, reject) => {
      this.fireAuth.signInWithEmailAndPassword(email, password).then(async (user) => {
        resolve(user);
      }).catch((error) => {
        this.util.toast(error, 'danger', 'bottom');
        reject(error);
      });
    });
  }

  async loginWithGoogle() {
    const googleUser = await GoogleAuth.signIn();
    const credentials = auth.GoogleAuthProvider.credential(googleUser.authentication.idToken);
    return await this.fireAuth.signInAndRetrieveDataWithCredential(credentials);
  }

  loginWithFacebook() {
    const provider = new auth.FacebookAuthProvider();
    provider.addScope('user_birthday');
    provider.addScope('user_gender');
    provider.addScope('user_gender');
    return this.fireAuth.signInWithPopup(provider);
  }

  createAccount(email: string, password: string) {
    console.log(`Email: ${email} Password: ${password}`);
    return this.fireAuth.createUserWithEmailAndPassword(email, password);
  }

  loginAnonymously() {
    return this.fireAuth.signInAnonymously();
  }

  signInWithCustomToken(token: string) {
    return this.fireAuth.signInWithCustomToken(token);
  }

  resetPassword(email: string) {
    return this.fireAuth.sendPasswordResetEmail(email);
  }

  changePassword(oldPass: string, newPass: string) {
    return new Promise((resolve, reject) => {
      this.fireAuth.signInWithEmailAndPassword(this.currentUser.email, oldPass).then((user) => {
        user.user.updatePassword(newPass).then(() => {
          resolve(true);
        }).catch((error) => {
          reject(error);
        });
      }).catch((error) => {
        reject(error);
      });
    });
  }

  logout() {
    return this.fireAuth.signOut().then(() => {
      this.storage.clear();
    }).catch((error) => {
      this.util.toast(error, 'danger', 'bottom');
    });
  }
}
